<template>
  <div class="gameplan">
    <ContentHeader />
    <div class="content-wrapper margin-top-20">

      <div class="create_box">
        <div class="normal_title">添加城市</div>
        <el-card class="box-card">
            <el-form :rules="editRules" label-position="right" :model="params" ref="createForm" :inline="true"
              class="form-box" label-width="100px">
              <el-form-item label="BU" class="item-lable" v-if="isHQ">
                <el-select v-model="buOrgId" placeholder="请选择BU" size="small" class="item" clearable>
                  <el-option v-for="item in buList" :key="item.value" :label="getName(item.orgName)" :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销售大区" class="item-lable" v-if="isHQ||isBU">
                <el-select v-model="regionOrgId" placeholder="请选择销售大区" size="small" class="item" clearable>
                  <el-option v-for="item in regionList" :key="item.value" :label="getName(item.orgName)" :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="城市" class="item-lable" prop="areaCode" v-if="isHQ||isBU||isRegion">
                <el-select v-model="params.areaCode" placeholder="请选择城市" size="small" class="item" @change="onAreaChanged" clearable>
                  <el-option v-for="item in areaList" :key="item.value" :label="getName(item.orgName)" :value="item.orgCode">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="名称" class="item-lable" prop="cityDisplayName">
                <el-input v-model="params.cityDisplayName" class="item" size="small" placeholder="请输入城市名称" clearable></el-input>
              </el-form-item>
              <div class="btn">
                <el-button size="small" class="btn-blue-plain" @click="handleCreate()">确定
                </el-button>
                <el-button size="small" class="btn-grey-plain" @click="handleResetCreate()">重置
                </el-button>
            </div>
            </el-form>
        </el-card>
      </div>

      <div class="normal_title">城市列表</div>
      <div class="normal_box" >

        <div class="search">
          <el-form :inline="true" :model="queryParams" ref="searchForm" class="searchForm">
            <el-form-item class="item" prop="prNumber">
              <el-input v-model="queryParams.cityDisplayName" placeholder="请输入城市池名称" size="small" suffix-icon="el-icon-search" clearable>
              </el-input>
            </el-form-item>
            <el-form-item class="item-btn">
              <el-button type="danger" size="small" @click="getGameplanCityPoolList">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="info" size="small" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="content-list ">
          <el-table v-loading="listLoading" :data="cityPoolList" :header-cell-style="{background:'#ebebeb',color:'black' }">
            <el-table-column label="城市显示名称" align="center">
              <template slot-scope="scope">{{scope.row.cityDisplayName}}</template>
            </el-table-column>
            <el-table-column label="BU" align="center">
              <template slot-scope="scope">{{getName(scope.row.buName)}}</template>
            </el-table-column>
            <el-table-column label="销售大区" align="center">
              <template slot-scope="scope">{{getName(scope.row.regionName)}}</template>
            </el-table-column>
            <el-table-column label="城市" align="center">
              <template slot-scope="scope">{{getName(scope.row.areaName)}}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="250">
              <template slot-scope="{ row }">
                <el-button type="primary" plain icon="el-icon-edit" size="mini" @click="showDialog(row)">编辑</el-button>
                <el-button type="primary" plain icon="el-icon-delete" size="mini" @click="handleDatele(row)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>

    <el-dialog title="修改" :visible.sync="dialogVisible" width="60%" :before-close="handleDialogClose"
      :close-on-click-modal="false">
      <el-form :model="updateParams" :rules="editRules" ref="editForm" label-width="100px">
        <el-form-item label="城市名称" prop="cityDisplayName">
          <el-input v-model="updateParams.cityDisplayName" placeholder="请输入城市名称" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button  style="margin-right:20px" size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button  size="small" type="danger" @click="beSure()">确 定</el-button> -->
        <el-button size="small" @click="handleDialogClose">取 消</el-button>
        <el-button size="small" type="danger" @click="handleUpdate()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ContentHeader from "@/components/content-header";
import gameplanApi from "@/api/gameplan";
import { mapGetters } from 'vuex'
export default {
  components: {
    ContentHeader,
  },
  data() {
    return {
      employeeLevel:'',
      listLoading: false,
      radio: '',
      queryParams: {
        cityDisplayName: '',
      },
      cityPoolForm:{},
      cityPoolList: [],
      params: {
        cityDisplayName: '',
        areaCode: '',
        cityPoolId: '',
        cityPoolStatus:''
      },
      updateParams:{
        cityDisplayName: '',
        cityPoolId:''
      },
      status: [
        {
          value: 1,
          label: "有效",
        },
        {
          value: 2,
          label: "无效",
        },
      ],
      dialogVisible: false,
      inputType: "新建",
      editRules: {
        cityDisplayName: [
          { required: true, message: "请输入城市名称", trigger: "blur" },
        ],
        areaCode: [
          { required: true, message: "请选择Area", trigger: "blur" },
        ],
      },
      buList:[],
      buOrgId:'',
      regionList:[],
      regionOrgId:'',
      areaList:[],
      areaCode:''
    };
  },
  watch:{
    "buOrgId"(val){
      this.regionOrgId = ''
      this.areaCode = ''
      this.params.areaCode = ''
      this.regionList = []
      this.areaList = []
      this.params.cityDisplayName = ''
      this.getGameplanCityPoolBaseOrgRegionList()
    },
    "regionOrgId"(val){
      //if(!val){
        //this.regionOrgId = ''
        this.areaCode = ''
        this.params.areaCode = ''
        this.areaList = []
        this.params.cityDisplayName = ''
      //}else {
        this.getGameplanCityPoolBaseOrgAreaList()
      //}
    },
  },
  computed:{
    ...mapGetters(['userInfo']),
    isHQ(){
      return this.employeeLevel>=90&&this.employeeLevel<100
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    }
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      this.employeeLevel = this.userInfo.employeeLevel
      this.regionList = []
      this.areaList=[]
      if(this.isBU){
        this.buOrgId = this.userInfo.orgDTO.parentOrgId
        //this.buOrgId =295// this.userInfo.buCode
        this.getGameplanCityPoolBaseOrgRegionList()
      }else  if(this.isRegion){
        this.buOrgId = this.userInfo.orgDTO.parentOrgId
        this.regionOrgId = this.userInfo.orgDTO.orgId
        //this.buOrgId =295// this.userInfo.buCode
        //this.getGameplanCityPoolBaseOrgRegionList()
        this.getGameplanCityPoolBaseOrgAreaList()
      }
      this.getGameplanCityPoolBaseOrgBuList()
      this.getGameplanCityPoolList();
    },
    async getGameplanCityPoolList() {
      this.listLoading = true;
      const { data } = await gameplanApi.getGameplanCityPoolList(
        this.queryParams
      );
      this.listLoading = false;
      if (data.resultCode === "0") {
        this.cityPoolList = data.resultData?.cityPoolList || [];
        //this.total = data.resultData.pageInfo.totalCounts
      }
    },
    async getGameplanCityPoolBaseOrgBuList() {
      const { data } = await gameplanApi.getGameplanCityPoolBaseOrgBuList();
      if (data.resultCode === "0") {
        this.buList = data.resultData?.buList || [];
      }
    },
    async getGameplanCityPoolBaseOrgRegionList() {
      let params = {
        buOrgId:this.buOrgId
      }
      const { data } = await gameplanApi.getGameplanCityPoolBaseOrgRegionList(params);
      if (data.resultCode === "0") {
        this.regionList = data.resultData?.regionList || [];
      }
    },
    async getGameplanCityPoolBaseOrgAreaList() {
      let params = {
        page:1,
        pageSize:10,
        buOrgId:this.buOrgId,
        regionOrgId:this.regionOrgId
      }
      const { data } = await gameplanApi.getGameplanCityPoolBaseOrgAreaList(params);
      if (data.resultCode === "0") {
        this.areaList = data.resultData?.areaList || [];
      }
    },
    // 重置
    handleReset() {
      this.queryParams = this.$options.data().queryParams;
      this.getGameplanCityPoolList();
    },
    handleResetCreate(){
      this.$refs.createForm.resetFields()
      this.buOrgId=''
      this.regionOrgId = ''
      this.init()
      this.params = this.$options.data().params;
    },
    onAreaChanged(val) {
      console.log(val)
      if (!val) {
        this.params.cityDisplayName = ''
        return
      }
      const areaObj = this.areaList.find(item => {
        return item.orgCode === val
      })
      if (areaObj) {
        this.params.cityDisplayName = this.getName(areaObj.orgName) || ''
      }
    },
    showDialog(row){
      this.updateParams.cityPoolId = row.cityPoolId
      this.updateParams.cityDisplayName = row.cityDisplayName
      this.dialogVisible = true
    },
    handleCreate() {
      this.$confirm(`是否要添加城市信息？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(async() => {
          this.$refs.createForm.validate(async (valid) => {
            console.log(valid);
            if (valid) {
              //this.params.areaCode = this.areaCode
              const { data } = await gameplanApi.gameplanCityPoolAdd(this.params);
              if (data.resultCode === "0") {
                this.$message.success(`添加成功`);
                this.getGameplanCityPoolList();
                this.$refs.createForm.resetFields()
                this.buOrgId=''
                this.regionOrgId = ''
                this.init()
              }
            }
          });
        }).catch(() => {
        });
      // this.dialogVisible = true;
    },
    handleUpdate() {
      this.$confirm(`是否要修改城市信息？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(async() => {
          this.$refs.editForm.validate(async (valid) => {
            if (valid) {
              let data = await gameplanApi.gameplanCityPoolUpdate(this.updateParams);
              if (data.data.resultCode === "0") {
                this.$message.success(`修改成功`);
                this.handleDialogClose();
                this.getGameplanCityPoolList();
              }
            }
          });
        }).catch(() => {
        });
    },
    handleDatele(row) {
      console.log(row);
      this.$confirm("是否确认删除该城市?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        type: "warning",
      })
        .then(async () => {
          const { data } = await gameplanApi.gameplanCityPoolDelete(
            row.cityPoolId
          );
          if (data.resultCode === "0") {
            this.$message.success(`删除成功`);
            this.getGameplanCityPoolList();
          }
        })
        .catch(() => { });
    },
    handleDialogClose() {
      this.$refs.editForm.resetFields()
      this.updateParams = {
        cityDisplayName: "",
      };
      this.dialogVisible = false;
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-card__body {
  padding: 0;
}

::v-deep .el-card {
  border: 0;
}

.header {
  height: 100px;
  background: url("../../assets/images/banner-menu.jpg") center no-repeat;
  background-size: cover;
}
.margin-top-20{
  margin-top: -50px;
}

.content {
  width: 100%;
  line-height: 20px;
  background-color: #f3f5f9;
  text-align: center;
  font-family: SourceHanSansSC-regular;
}
.box-card {
      width: 894px;
      line-height: 20px;
      border-radius: 8px;
      font-size: 14px;
.form-box {
        display: flex;
        flex-wrap: wrap;
        margin-top:30px;
        .item-lable {
          // border: 1px solid ;
          margin-top: 5px;
          height: 30px;

          .item {
            width: 170px;
            height: 30px;
            border-radius: 4px;
            text-align: left;
          }
        }

        .btn {
          width:100%;
          margin:10px 0 30px 0;
          display: flex;
          justify-content: center;
        }
      }


    }
.card_box {
      min-height: 200px;
    }

    .item-list {
      width: 100%;
      //height: 130px;
      border-radius: 8px;
      //text-align: center;
      margin-bottom: 25px;

      .item_list_top {
        width: 100%;
        //height: 58px;
        background-color: #ffd6e8;
        display: flex;
        justify-content: space-between;
        padding: 13px 0;

        .top_title_box {
          display: flex;
          align-items: center;

          .top_left {
            // width: 172px;
            font-weight: 600;
            color: #cd1231;
            font-size: 16px;
            text-align: left;
            margin: 0 40px 0 20px;
            min-width: 180px;
          }

          .top_center {
            // width: 174px;
            font-size: 13px;
            font-weight: bold;
          }
        }

        .right_btn_box {
          display: flex;
        }

        .right_btn {
          padding: 5px 10px;
          font-size: 12px;
          border-radius: 4px;
          text-align: center;
          background-color: #ffffff;
          border: 1px solid #2185d0;
          color: #2185d0;
          margin-right: 20px;
          cursor: pointer;
        }
      }

      .item_list_bottom {
        width: 100%;
        //height: 72px;
        display: flex;
        justify-content: flex-start;
        padding-left: 20px;
        line-height: 25px !important;
        padding-bottom: 15px;

        .bottom_left {
          min-width: 120px;

          .first {
            display: flex;
            margin-bottom: 4px;
            margin-top: 10px;

            .img {
              margin-top: 6px;
              width: 15px;
              margin-right: 3px;
            }

            .text {
              font-size: 13px;
              text-align: left;
              margin-right:50px;
            }
          }

          .second {
            height: 20px;
            font-size: 13px;
            text-align: left;
          }
        }

        .center {
          margin-left: 58px;
          font-size: 13px;
          text-align: left;
          color: #101010;

          .center-first {
            margin-top: 10px;
          }
        }

        .right {
          flex: 0.88;
          line-height: 68px;
          font-size: 16px;
          text-align: right;
          color: #bcbcbc;
        }
      }
    }

.no_data {
  background-color: #fff;
  color: grey;
  width: 100%;
  min-height: 120px;
  line-height: 120px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 10px;
}

.form_style {
  margin: 10px 20px;
}

.edit_dialog {
  .el-select {
    width: 100%;
  }
}

.content-wrapper{
  width:900px;
}

.content-header {
  height: 100px;
  background-size: cover;
}

.content-list {
  margin-top: -10px;
}

.content-pagination {
  text-align: center;
  margin-top: $content-large;
}

.search-row {
  display: flex;
  justify-content: space-between;

  .el-input {
    width: 180px;
    margin-right: $content-middle;
  }
}
</style>
